export const APP_DIR = {
  CREDIT_CARD_MATCHER: 'apps/credit-card-matcher',
  BUDGETEER: 'apps/budgeteer',
  RENTESJEKK: 'apps/rentesjekk',
  LOAN_FINDER: 'apps/loan-finder',
  FINANCE_DICTIONARY: 'apps/finance-dictionary',
}

export const APP_ROUTES = {
  CREDIT_CARD_MATCHER: '/kredittkort/finn-beste-kredittkort/',
  BUDGETEER: '/tips-og-rad/budsjett/',
  RENTESJEKK: '/boliglan/rentesjekk/',
  LOAN_FINDER: '/tips-og-rad/hvilket-lan-skal-jeg-velge/',
  FINANCE_DICTIONARY: '/tips-og-rad/ordliste/',
};

export const APP_PORTS = {
  GATEWAY: 3000,
  CREDIT_CARD_MATCHER: 8080,
  BUDGETEER: 8081,
  RENTESJEKK: 8082,
  LOAN_FINDER: 8083,
  FINANCE_DICTIONARY: 8084,
};

export const APP_SECRETS = {
  CREDIT_CARD_MATCHER: [
    'LENDO_ENVIRONMENT',
  ],
  BUDGETEER: [
    'LENDO_ENVIRONMENT',
  ],
  RENTESJEKK: [
    'LENDO_ENVIRONMENT',
  ],
  LOAN_FINDER: [
    'LENDO_ENVIRONMENT',
  ],
  FINANCE_DICTIONARY: [
    'LENDO_ENVIRONMENT',
  ],
};

// Helper to get all unique secrets across all apps
export const getAllSecrets = () => {
  const allSecrets = new Set();
  Object.values(APP_SECRETS).forEach(secrets => {
    secrets.forEach(secret => allSecrets.add(secret));
  });
  return Array.from(allSecrets);
};
